import apiV2 from "api-v2";
import type { ComplianceQuestion } from "newui/features/Settings/types/ComplianceQuestion.type";

/** Unwrap the `{ data: T }` envelope returned by apiV2 endpoints. */
const unwrap = <T>(responseData: unknown): T => {
	if (responseData && typeof responseData === "object" && "data" in responseData) {
		return (responseData as Record<string, unknown>).data as T;
	}
	return responseData as T;
};

const BASE = "/compliance-questions";

// GET — list ordered by sort_order
export const getComplianceQuestions = async (): Promise<ComplianceQuestion[]> => {
	const response = await apiV2.get(BASE);
	return unwrap<ComplianceQuestion[]>(response.data) ?? [];
};

// POST — create
export const createComplianceQuestion = async (
	question: string
): Promise<ComplianceQuestion> => {
	const response = await apiV2.post(BASE, { question });
	return unwrap<ComplianceQuestion>(response.data);
};

// PUT /{id} — update
export const updateComplianceQuestion = async (
	id: number,
	question: string
): Promise<ComplianceQuestion> => {
	const response = await apiV2.put(`${BASE}/${id}`, { question });
	return unwrap<ComplianceQuestion>(response.data);
};

// DELETE /{id} — remove
export const deleteComplianceQuestion = async (id: number): Promise<void> => {
	await apiV2.delete(`${BASE}/${id}`);
};

// PUT /reorder — persist the full ordered id array
export const reorderComplianceQuestions = async (
	ids: number[]
): Promise<ComplianceQuestion[]> => {
	const response = await apiV2.put(`${BASE}/reorder`, { ids });
	return unwrap<ComplianceQuestion[]>(response.data) ?? [];
};
